import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export const fetchUser = createAsyncThunk(
  "auth/fetchUser",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        return rejectWithValue("No token found");
      }

      const response = await axios.get(`${API_URL}/api/v1/auth/user`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      console.log(response.data, "user data fetched");
      return response.data;
    
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Error fetching user"
      );
    }
  }
);

export const registerUser = createAsyncThunk(
  "auth/register",
  async ({ name, email, password, referralCode }, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${API_URL}/api/v1/auth/register`, {
        name,
        email,
        password,
        referralCode,
        role: "visitant",
        willSubscribe: false,
        IDOfTheSubscriptionPlanThatTheUserChose: null
      });
      console.log(response);
      
      // Guardar el token en localStorage después del registro exitoso
      if (response.data && response.data.token) {
        localStorage.setItem("token", response.data.token);
      }
      
      return response.data;
    } catch (err) {
      console.log(err);
      
      return rejectWithValue(err.response?.data?.message || "Registro fallido");
    }
  }
);

export const loginUser = createAsyncThunk(
  "auth/login",
  async ({ email, password }, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${API_URL}/api/v1/auth/login`, {
        email,
        password,
      });
      localStorage.setItem("token", response.data.token);
      console.log(response.data, "user data logged in");
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Credenciales incorrectas"
      );
    }
  }
);

export const recoverPassword = createAsyncThunk(
  "auth/recoverPassword",
  async (email, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${API_URL}/api/v1/auth/recover-password`,
        { email }
      );
      return response.data.message;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Error al recuperar contraseña"
      );
    }
  }
);

export const resetPassword = createAsyncThunk(
  "auth/resetPassword",
  async ({ token, newPassword }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${API_URL}/api/v1/auth/reset-password`,
        {
          token,
          newPassword,
        }
      );
      return response.data.message;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message ||
          "Ocurrió un error al cambiar la contraseña"
      );
    }
  }
);

const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: null,
    token: localStorage.getItem("token") || null,
    loading: false,
    error: null,
    recoverySuccess: false,
    recoveryMessage: "",
    resetSuccess: false,
    resetMessage: "",
    loggedOut: false,
  },
  reducers: {
    logout: (state) => {
      state.user = null;
      state.token = null;
      localStorage.removeItem("token");
      state.loggedOut = true;
    },
    clearAuthState: (state) => {
      state.error = null;
      state.recoverySuccess = false;
      state.resetSuccess = false;
      state.recoveryMessage = "";
      state.resetMessage = "";
      state.loggedOut = false;
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(fetchUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
      })
      .addCase(fetchUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(registerUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(registerUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
      })
      .addCase(registerUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.token = action.payload.token;
        state.user = action.payload.user;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(recoverPassword.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.recoverySuccess = false;
      })
      .addCase(recoverPassword.fulfilled, (state, action) => {
        state.loading = false;
        state.recoverySuccess = true;
        state.recoveryMessage = action.payload;
      })
      .addCase(recoverPassword.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.recoverySuccess = false;
      })

      .addCase(resetPassword.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.resetSuccess = false;
      })
      .addCase(resetPassword.fulfilled, (state, action) => {
        state.loading = false;
        state.resetSuccess = true;
        state.resetMessage = action.payload;
      })
      .addCase(resetPassword.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.resetSuccess = false;
      });
  },
});

export const { logout, clearAuthState } = authSlice.actions;
export default authSlice.reducer;
